import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/lib/LanguageContext";
import LanguageSelector from "@/pages/LanguageSelector";
import MainSite from "@/pages/MainSite";
import AdminLeads from "@/pages/AdminLeads";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LanguageSelector />} />
          <Route path="/:lang" element={<MainSite />} />
          <Route path="/admin" element={<AdminLeads />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
